import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PackageCounterPage } from './package-counter.page';

const routes: Routes = [
  {
    path: '',
    component: PackageCounterPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PackageCounterPageRoutingModule {}
